document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  let speed = 300;

  if (window.innerWidth > 687) {
    gsap.from("#scroll", {
      yPercent: 110,
      delay: 1,
      duration: 1,
    });

    let rotate = gsap.timeline({
      repeat: -1,
    });

    rotate.to("#savage", {
      rotate: 5,
      duration: 1,
    });
    rotate.to("#savage", {
      rotate: 50,
      duration: 1,
    });

    let rotate1 = gsap.timeline({
      repeat: -1,
    });
    rotate1.to("#experience", {
      rotate: -25,
      duration: 1,
    });
    rotate1.to("#experience", {
      rotate: 5,
      duration: 1,
    });
    let rotate2 = gsap.timeline({
      repeat: -1,
    });
    rotate2.to("#plump", {
      rotate: 25,
      duration: 1,
    });
    rotate2.to("#plump", {
      rotate: -5,
      duration: 1,
    });
    let rotate3 = gsap.timeline({
      repeat: -1,
    });
    rotate3.to("#playlist", {
      rotate: -25,
      duration: 1,
    });
    rotate3.to("#playlist", {
      rotate: 5,
      duration: 1,
    });

    let rotate4 = gsap.timeline({
      repeat: -1,
    });
    rotate4.to("#spray", {
      rotate: 10,
      duration: 1,
    });
    rotate4.to("#spray", {
      rotate: 40,
      duration: 1,
    });

    gsap.to(".destello", {
      rotate: 45,
      repeat: -1,
    });
    gsap.to(".destello", {
      duration: 1,
      scale: 0.1,
      y: 40,
      ease: "power1.inOut",
      repeat: -1,
      yoyo: true,
      stagger: {
        grid: [7, 15],
        from: "center",
        ease: "power2.in",
        amount: 1.5,
      },
    });
    let flash = gsap.timeline({
      repeat: -1,
    });
    flash.to(".stagger", {
      opacity: 0,
      duration: 0.7,
      stagger: 0.5,
    });
    let liked = gsap.to(".hearts img:not(#stay)", {
      x: 150,
      y: -2 * speed,
      scale: 2.5,
      ease: "slow",
      stagger: 1,
      duration: 4,
      repeat: -1,
    });
    liked.pause();

    // let rotate5 = gsap.timeline({
    //     repeat: -1,

    // });

    // rotate5.to("#savage2", {
    //     rotate: 25, duration: 1,
    // });
    // rotate5.to("#savage2", {
    //     rotate: -5,
    //     duration: 1,
    // });

    // let rotate6 = gsap.timeline({
    //     repeat: -1,

    // });
    // rotate6.to("#experience2", {
    //     rotate: -25, duration: 1,
    // });
    // rotate6.to("#experience2", {
    //     rotate: 5,
    //     duration: 1,
    // });
    // let rotate7 = gsap.timeline({
    //     repeat: -1,

    // });
    // rotate7.to("#plump2", {
    //     rotate: 25, duration: 1,
    // });
    // rotate7.to("#plump2", {
    //     rotate: -5,
    //     duration: 1,
    // });

    gsap.from(".flex-center.intro ", {
      scrollTrigger: {
        trigger: "#intro",
        start: "top center",
        end: "top top",
       // toggleActions: "restart none reverse none",
      },
      y: -3,
      x: 10 * speed,
      rotate: 70,
      scale: 2,
      ease: "power1.in",
      duration: 2,
    });

    gsap.to("#scroll", {
      scrollTrigger: {
        trigger: "#favoritos",
        start: "top bottom",
        end: "+=100 bottom",

       // toggleActions: "restart none reverse none",
      },
      y: 200,
      autoAlpha: 0,
      ease: "power1.out",
      duration: 1,
    });
    //     gsap.from("#favoritos", {
    //         scrollTrigger: {
    //             trigger: '#favoritos',
    //             start: 'top top',
    //             end: 'bottom bottom',
    // pin:true,markers:true
    //         },

    //     });
    gsap.from("#logoSvg", {
      scrollTrigger: {
        trigger: "#favoritos",
        start: "top bottom",
        end: "+=100 bottom",

        toggleActions: "restart none reverse none",
      },
      opacity: 1,
      yPercent: 150,
      scale: 2,
      ease: "power1.out",
      duration: 1,
    });
    gsap.from(".header__heading-logo", {
      scrollTrigger: {
        trigger: "#favoritos",
        start: "top bottom",
        end: "+=100 bottom",

       // toggleActions: "restart none reverse none",
      },
      opacity: 0,
      ease: "power1.out",
      duration: 1,
    });
    gsap.from(".flex-center.fav ", {
      scrollTrigger: {
        trigger: "#favoritos",
        start: "top center",
        end: "bottom bottom",

        // markers: true,
       // toggleActions: "restart none reverse none",
      },
      y: -3,
      x: -10 * speed,
      rotate: 270,
      scale: 2,
      ease: "power1.out",
      duration: 1,
      delay: 1,
    });
    // gsap.from(".h1l", {
    //   scrollTrigger: {
    //     trigger: "#favoritos",
    //     start: "top center",
    //     end: "bottom bottom",

    //     toggleActions: "restart none none none",
    //   },
    //   x: -5 * speed,
    //   ease: "power1.in",
    //   duration: 1,
    // });
    // gsap.from(".p1r", {
    //   scrollTrigger: {
    //     trigger: "#favoritos",
    //     start: "top center",
    //     end: "bottom bottom",
    //     toggleActions: "restart none none none",
    //   },
    //   x: 5 * speed,
    //   ease: "power1.in",
    //   duration: 1,
    // });
    // gsap.from(".productos", {
    //   scrollTrigger: {
    //     trigger: "#favoritos",
    //     start: "top center",
    //     end: "bottom bottom",

    //     toggleActions: "restart none none none",
    //   },
    //   y: 3 * speed,
    //   ease: "power1.in",
    //   duration: 2,
    // });
    gsap.from("#titleCielo", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: -2 * speed,
      ease: "power1.in",
      duration: 1,
      delay: 1,
    });

    gsap.from("#nube1", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: 5 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.from("#nube2", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: 7 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.from("#nube3", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: 6 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.from("#nube4", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: -5 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.from("#nube5", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: -2 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.to(".hearts img", {
      scrollTrigger: {
        trigger: "#rrss",
        start: "top center",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      onStart: () => {
        liked.play();
      },
    });

    gsap.from(".header__icon", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top center",
        end: "bottom bottom",
        onComplete: () => {
          for (let i = 0; i < hIcon.length; i++) {
            hIcon[i].style.color = "var(--green)";
          }
        },
        onCompleteReverse: () => {
          for (let i = 0; i < hIcon.length; i++) {
            hIcon[i].style.color = "var(--red)";
          }
        },
        toggleActions: "restart none none none",
      },
    });
  } else {
    gsap.from("#scroll", {
      yPercent: 110,
      delay: 1,
      duration: 1,
    });
    /*   gsap.from(".nav", {
      y: -300,
      duration: 2,
    });
*/
    let rotate = gsap.timeline({
      repeat: -1,
    });

    rotate.to("#savage", {
      rotate: 5,
      duration: 1,
    });
    rotate.to("#savage", {
      rotate: 50,
      duration: 1,
    });

    let rotate1 = gsap.timeline({
      repeat: -1,
    });
    rotate1.to("#experience", {
      rotate: -25,
      duration: 1,
    });
    rotate1.to("#experience", {
      rotate: 5,
      duration: 1,
    });
    let rotate2 = gsap.timeline({
      repeat: -1,
    });
    rotate2.to("#plump", {
      rotate: 25,
      duration: 1,
    });
    rotate2.to("#plump", {
      rotate: -5,
      duration: 1,
    });
    let rotate3 = gsap.timeline({
      repeat: -1,
    });
    rotate3.to("#playlist", {
      rotate: -25,
      duration: 1,
    });
    rotate3.to("#playlist", {
      rotate: 5,
      duration: 1,
    });

    let rotate4 = gsap.timeline({
      repeat: -1,
    });
    rotate4.to("#spray", {
      rotate: 10,
      duration: 1,
    });
    rotate4.to("#spray", {
      rotate: 40,
      duration: 1,
    });

    gsap.to(".destello", {
      rotate: 45,
      repeat: -1,
    });
    gsap.to(".destello", {
      duration: 1,
      scale: 0.1,
      y: 40,
      ease: "power1.inOut",
      repeat: -1,
      yoyo: true,
      stagger: {
        grid: [7, 15],
        from: "center",
        ease: "power2.in",
        amount: 1.5,
      },
    });
    let flash = gsap.timeline({
      repeat: -1,
    });
    flash.to(".stagger", {
      opacity: 0,
      duration: 0.7,
      stagger: 0.5,
    });
    let liked = gsap.to(".hearts img:not(#stay)", {
      x: 150,
      y: -2 * speed,
      scale: 2.5,
      ease: "slow",
      stagger: 1,
      duration: 4,
      repeat: -1,
    });
    liked.pause();

    /* gsap.from(".flex-center.intro", {
      scrollTrigger: {
        trigger: "#intro",
        pin: true,
        start: "10px top",
        end: "bottom top",
       // toggleActions: "restart none reverse none",
      },
      y: -3,
      x: 10 * speed,
      rotate: 70,
      scale: 2,
      ease: "power1.in",
      duration: 2,
    }); */

    gsap.to("#scroll", {
      scrollTrigger: {
        trigger: "#favoritos",
        start: "top bottom",
        end: "+=100 bottom",

       // toggleActions: "restart none reverse none",
      },
      y: 200,
      autoAlpha: 0,
      ease: "power1.out",
      duration: 1,
    });

    gsap.from("#logoSvg", {
      scrollTrigger: {
        trigger: "#favoritos",
        start: "top bottom",
        end: "+=100 bottom",
       // toggleActions: "restart none reverse none",
      },
      yPercent: 150,
      scale: 2,
      ease: "power1.out",
      duration: 1,
    });

    gsap.from("#nube1", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: 5 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.from("#nube2", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: 7 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.from("#nube3", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: 6 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.from("#nube4", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: -5 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.from("#nube5", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top bottom",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      x: -2 * speed,
      ease: "slow",
      duration: 4,
    });
    gsap.to(".hearts img", {
      scrollTrigger: {
        trigger: "#rrss",
        start: "top center",
        // markers: true,
        end: "bottom bottom",
        toggleActions: "restart none none none",
      },
      onStart: () => {
        liked.play();
      },
    });

    gsap.from(".header__icon", {
      scrollTrigger: {
        trigger: "#cielo",
        start: "top center",
        end: "bottom bottom",
        onComplete: () => {
          for (let i = 0; i < hIcon.length; i++) {
            hIcon[i].style.color = "var(--green)";
          }
        },
        onCompleteReverse: () => {
          for (let i = 0; i < hIcon.length; i++) {
            hIcon[i].style.color = "var(--red)";
          }
        },
        toggleActions: "restart none none none",
      },
    });
  }
});
let hIcon = document.querySelectorAll(".header__icon");

//for (let i = 0; i < hIcon.length; i++) {
//hIcon[i].style.color = "var(--green)";
//}

//FUNCION OPEN MODO DE USO
function openA(e) {
  if (e == "htu") {
    if (document.querySelector("p.ing").className != "hidden") {
      let btn2 = document.querySelector("p.ing");
      btn2.classList.add("hidden");
    }
    let btn = document.querySelector("p.htu");
    btn.classList.remove("hidden");
  } else if (e == "ing") {
    if (document.querySelector("p.htu").className != "hidden") {
      let btn2 = document.querySelector("p.htu");
      btn2.classList.add("hidden");
    }
    let btn = document.querySelector("p.ing");
    btn.classList.remove("hidden");
  }
}
